import { useEffect, useMemo, useRef, useState } from "react";
import { LETTER_INLINE_STYLES, letterPageHtml } from "@/lib/inquiryForm";

const LETTER_WIDTH = 770;

export default function LetterView({ inquiry, branding, testId }) {
  const ref = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const apply = () => setScale(Math.min(1, el.clientWidth / LETTER_WIDTH));
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const html = useMemo(() => (
    "<style>@import url('https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap');</style>"
    + `<style>${LETTER_INLINE_STYLES}</style>`
    + `<div class="letter-inline">${letterPageHtml(inquiry, branding)}</div>`
  ), [inquiry, branding]);

  return (
    <div ref={ref} className="w-full overflow-hidden rounded-xl border bg-white" data-testid={testId}>
      <div style={{ zoom: scale }} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
